import SignUpContainer from "./signup.container";

export default SignUpContainer;
